module.exports = __webpack_public_path__ + "img/success.16f7efde.png";